import type { RouteObject } from "react-router";
import { Redirect } from "./Redirect";

// Old URLs kept forever (docs/product/redesign.md §2.1): links in pushes, the inbox, emails and bookmarks still
// land. They sit after the features' routes, so while a feature still serves one of these paths itself, its
// screen wins; once it moves, the redirect takes over.

const redirect = (path: string, to: string, search?: string): RouteObject => ({
  path,
  element: <Redirect to={to} {...(search === undefined ? {} : { search })} />,
});

export const redirects: RouteObject[] = [
  redirect("quests", "/today"),
  // Until the Today screen ships under its new name, /today opens the old one (never both missing).
  redirect("today", "/quests"),
  redirect("podiums", "/leagues", "?tab=hall&board=holders"),
  redirect("trades", "/market/trades"),
  redirect("trades/new", "/market/trades/new"),
  redirect("trades/:tradeId", "/market/trades/:tradeId"),
  redirect("me/showcase", "/me", "?edit=showcase"),
];
